import {AxiosInstance} from "axios";
import {isNullOrUndefined} from "util";
import download = require("downloadjs");
import moment = require("moment");

export default class PostcodeApi {

	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Download postcodes xlsx
	 * @returns {Promise<void>}
	 */
	downloadPostcodes() {
		const url = `/api/web/postcodes/export`;
		const query = {responseType: "blob"};
		return this.axiosInstance.get(url, query).then((resp) => {
			const disposition = resp.headers['content-disposition'];
			const filename = disposition.match(/filename=(.*)/)[1];
			const optName = `POSTCODES_${moment().format("YYYY-MM-DD_HH-MM")}`;
			download(resp.data, isNullOrUndefined(filename) ? optName : filename);
		});
	}

	/**
	 * Upload postcodes xlsx
	 * @param {File} file
	 */
	uploadPostcodes(file: File) {
		const url = `/api/web/postcodes/import`;
		const config = {
			headers: {'content-type': 'multipart/form-data'}
		};
		const formData = new FormData();
		formData.append('file', file);
		return this.axiosInstance.post(url, formData, config);
	}
}
